// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-steps-item-icon {\n  position: relative;\n  top: 10px;\n}\n.ant-steps-vertical\n  > .ant-steps-item\n  > .ant-steps-item-container\n  > .ant-steps-item-tail {\n  position: absolute;\n  top: 10px;\n  left: 16px;\n  width: 1px;\n  height: 100%;\n  padding: 38px 0 6px;\n}\n\n.ant-steps-item-title {\n  margin-left: 20px;\n  position: relative;\n  top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
